import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { PriceDisplay } from '../price/PriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CompareSeatCard({
  card,
  currencyCode
}) {
  const {
    title,
    description,
    pricePerSeat,
    features
  } = card;
  return /*#__PURE__*/_jsxs(CardWrapper, {
    flex: "1 1 280px",
    padding: "600",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h3",
      typography: "heading-300",
      children: title
    }), pricePerSeat !== undefined && /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "compareSeats.pricePerSeat",
        options: {
          price: /*#__PURE__*/_jsx(PriceDisplay, {
            price: pricePerSeat,
            currencyCode: currencyCode
          })
        }
      })
    }), description && /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      marginBlock: "400",
      children: description
    }), features.length > 0 && /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "400",
      role: "list",
      children: features.map((feature, index) => /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        role: "listitem",
        children: [/*#__PURE__*/_jsx(SuccessIcon, {
          color: "text-core-default"
        }), /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          children: feature
        })]
      }, `${index}-${feature}`))
    })]
  });
}